import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Container from "components/Container"
import theme from "styles/theme"
import BlockHeader from "components/BlockHeader"
import Footnotes from "components/Footnotes"
import ResponsiveTable from "components/ResponsiveTable"

const TableBlock = ({ label, title, tables }) => (
  <Container
    max={1140}
    wrapperStyles={theme.expandQueries(
      {
        "--blockPadding": ["80px", "60px", "45px"],
        "--inlinePadding": ["74px", "74px", "40px", "24px"],
        padding: "var(--blockPadding) var(--inlinePadding)",
      },
      ["root", theme.tablet, theme.mobile, theme.mobilePortrait]
    )}
  >
    <BlockHeader label={label} title={title} />

    {tables.map((table, index) => (
      <TableEntry key={index} {...table} />
    ))}
  </Container>
)

export default TableBlock

export const TableEntry = ({ heading, data, footnotes, className }) => (
  <div
    css={theme.expandQueries({
      marginTop: [60, 50, 30],
      "& + &": {
        marginTop: [65, 55, 45],
      },
    })}
    className={className}
  >
    {heading && (
      <h3
        css={{
          ...theme.t4,
          textAlign: "center",
          marginBottom: "1em",
        }}
      >
        {heading}
      </h3>
    )}

    <ResponsiveTable headings={data.rows[0].cells} rows={data.rows.slice(1)} />

    {footnotes?.length > 0 && <Footnotes>{footnotes}</Footnotes>}
  </div>
)

TableEntry.propTypes = {
  heading: PropTypes.string,
  data: PropTypes.shape({
    rows: PropTypes.arrayOf(
      PropTypes.shape({
        cells: PropTypes.array.isRequired,
      }).isRequired
    ).isRequired,
  }).isRequired,
  footnotes: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
}

TableBlock.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tables: PropTypes.arrayOf(PropTypes.shape(TableEntry.propTypes)).isRequired,
}

export const query = graphql`
  fragment TableBlock on SanityTableBlock {
    label
    title
    tables {
      heading
      data {
        rows {
          mode
          cells
        }
      }
      footnotes
    }
  }
`
